import { FunctionComponent, useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Text } from "components/text";
import useCartaObjectStorage from "hooks/useCartaObjectStorage";
import { NavigationLink } from "components/navigation";
import { IconButton, Alert } from "@mui/material";
//import QrCodeIcon from "components/icons/QrCodeIcon";
import QRCode from "react-qr-code";
import { QrCode as QrCodeIcon } from "@mui/icons-material";
import { CollectionForm as CollectionFormComponent } from "components/collectionsForm";
import { IFormSchemaResponse, NativeId } from "data/types";
import { DragNDropWrapper } from "components/dragNDrop";





export const CollectionForm: FunctionComponent = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [error, setError] = useState<string>();
  const [connectionId, setConnectionId] = useState<string | undefined>(undefined);
  const [nativeIds, setNativeIds] = useState<NativeId[]>([]);
  const [schema, setSchema] = useState<IFormSchemaResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const qrcode = useRef<HTMLDivElement>(null);
  const cartaObjectStorage = useCartaObjectStorage();
  

  const openQrCode = () => {
    const qrWindow = window.open("", "", "width=600,height=400,top=0,left=0");
    if (!qrWindow) {
      return;
    }
    qrWindow.document.write(qrcode.current?.innerHTML ?? "");
    qrWindow.document.close();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if(!cartaObjectStorage){return;}
        const _search = new URLSearchParams(location.search);
        const key = _search.get("key");
        const connectionId = _search.get("connectionId");
        // Support opening multiple existing forms at once: nativeId may appear
        // more than once in the query string (?nativeId=A&nativeId=B&...).
        const nativeIdParams = _search.getAll("nativeId");
        const parentNativeId = _search.get("parentNativeId");

        let collectionProps;

        if (key) {
          collectionProps = { projectId: projectId, key: key };
        } else if (connectionId && nativeIdParams.length > 0) {
          const parsedNativeIds = nativeIdParams.map((n) => JSON.parse(n));
          setNativeIds(parsedNativeIds);
          setConnectionId(connectionId);
          collectionProps =
            parsedNativeIds.length === 1
              ? {
                  projectId: projectId,
                  connectionId: connectionId,
                  node: { nativeId: parsedNativeIds[0] },
                  parentNode: {
                    nativeId: parentNativeId ? JSON.parse(parentNativeId) : {},
                  },
                }
              : {
                  projectId: projectId,
                  connectionId: connectionId,
                  nodes: parsedNativeIds.map((nativeId) => ({ nativeId })),
                };
        }

        if (!collectionProps) {
          throw new Error("Not enough data to construct collection request.");
        }

        const schema = await cartaObjectStorage.getFormSchema(collectionProps);
        setSchema(schema);
        setLoading(false);
      } catch (error) {
        setError(error instanceof Error ? error.message : "An unknown error occurred.");
        setLoading(false);
      }
    };

    fetchData();
  }, [location, projectId, cartaObjectStorage]);

  if (loading) {
    return (
      <Text size="medium" padding="center">
        Loading form schema...
      </Text>
    );
  }

  if (error) {
    return (
      <Alert severity="error">
        {error}
      </Alert>
    );
  } else {
    return (
      <DragNDropWrapper>
      <div style={{ display: "flex", flexGrow: 1, flexDirection: "column", width: "100%" }}>
        <h2>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <NavigationLink to={`/${projectId}`}>
              {schema?.schema?.title || ""}
            </NavigationLink>
            {nativeIds.length > 0 ? null : (
              <>
                <div style={{ display: "none" }} ref={qrcode}>
                  <h2>{schema?.schema?.title || ""}</h2>
                  <QRCode size={256} value={document.location.toString()} />
                </div>
                <IconButton
                  onClick={openQrCode}
                  style={{ backgroundColor: "#777", color: "white", marginLeft: "1rem" }}>
                  <QrCodeIcon />
                </IconButton>
              </>
            )}
          </div>
        </h2>
        <CollectionFormComponent projectId={projectId} connectionId={connectionId} schema={schema}/>

      </div>
      </DragNDropWrapper>
    );
  }
};

